// Components that animate the HEIGHT of in-flow content (accordions, expanding
// panels) broadcast it here. iOS Safari adjusts the scroll position while the
// document height is changing — and for a short while AFTER it stops (animated
// scroll clamp) — firing scroll events that are indistinguishable from user
// scrolling. The hide-on-scroll header listens for this event and freezes its
// scroll evaluation for the announced duration, breaking the
// "header reacts → viewport shifts → another scroll event" feedback loop that
// visibly shakes the page on iPhone.
export const VF_LAYOUT_ANIMATION_EVENT = "vf-layout-animation";

// While the animation runs, <html> also carries this class. CSS uses it to
// temporarily UN-promote permanently composited in-flow elements (e.g. Splide
// carousel lists, which ship backface-visibility:hidden): iOS WebKit re-snaps
// composited layers to the device pixel grid on every frame their document
// position changes, so rails below an opening accordion visibly wobble while
// everything around them moves smoothly. Dropping the promotion for the few
// hundred ms of the animation makes them render like normal content; it is
// restored immediately afterwards, so carousel drag performance is untouched
// (nobody can drag a rail and tap an accordion in the same instant).
export const VF_LAYOUT_ANIMATING_CLASS = "vf-layout-animating";

let animatingClassTimer: number | null = null;
const ANIMATING_CLASS_BUFFER_MS = 150;

export const notifyLayoutAnimation = (durationMs: number) => {
  if (typeof window === "undefined") return;

  const duration = Math.max(0, durationMs);

  window.dispatchEvent(
    new CustomEvent(VF_LAYOUT_ANIMATION_EVENT, {
      detail: { durationMs: duration },
    })
  );

  document.documentElement.classList.add(VF_LAYOUT_ANIMATING_CLASS);
  if (animatingClassTimer !== null) {
    window.clearTimeout(animatingClassTimer);
  }
  animatingClassTimer = window.setTimeout(() => {
    animatingClassTimer = null;
    document.documentElement.classList.remove(VF_LAYOUT_ANIMATING_CLASS);
  }, duration + ANIMATING_CLASS_BUFFER_MS);
};
